module.exports = __webpack_public_path__ + "img/icon-upload.907ebb15.svg";